'use client';

import AddToPlannerBedButton from '@/components/AddToPlannerBedButton';

export default function AddToBedButton({
  plantId,
  plantName,
}: {
  plantId: string;
  plantName: string;
}) {
  return (
    <AddToPlannerBedButton
      plantId={plantId}
      plantName={plantName}
      placementMetadata={{ plantName }}
    />
  );
}
